<template>
  <div id="edit__project__modal" class="project-modal edit-deliverable-modal edit-project-modal"
    :class="!userCanEditProject ? 'read-only' : ''">
    <div class="project--top--section">
      <div class="row">
        <div class="col-md-8 d-flex left--side">
          <div class="project--page--title">
            <h2 class="d-inline-block">
              <div class="project-icon bigger-icon pointer-default"
                :style="{ backgroundColor: getProjectColor(projectDetail) }">
                <img src="@/csmworkflow/img/white-folder.svg" />
              </div>
            </h2>
            <div class="text--section">
              <div class="project--department--wrap">

                <ProjectDepartments :deliverable="projectDetail" />
              </div>
              <label class="mb-0 w-100">
                <h1 style="line-height: 1;" @click="activateTitleField"
                  class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle">{{
                    projectDetail.title || 'Click to set...' }}</h1>
                <textarea v-click-outside="outside" ref="deliverableTitle" v-show="editTitle"
                  v-model="projectDetail.title" type="text" placeholder="Project title..."
                  class="form-control mb-3 title-field exclude-outside-click h1" @change="updateProjectTitle"
                  @blur="editTitle = false;"></textarea>
              </label>
              <div class="project-number"><span>Project Number: {{ projectDetail.project_number }}</span></div>
              <div class="project-due-date">
                Deadline:
                <span ref="refDatepickerWrapper" class="editable-project-due-date" @click="projectDueDateClick">
                  <div class="custom-field-outside-bg-mobile" v-show="editProjectDueDateBg"></div>
                  <vuejs-datepicker ref="projectDueDate" v-model="projectDetail.due_date" @input="updateProjectDueDate"
                    @focusin.native="findPosition" @selected="projectDueDateSelected"
                    v-field-dismiss="editProjectDatePickerClickOutside" placeholder="No Date">
                    <div slot="beforeCalendarHeader" class="calender-header">
                      <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
                      <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
                    </div>
                  </vuejs-datepicker>
                </span>
              </div>
            </div>
          </div>
          <div v-if="projectDeliverables.length" class="project--milestones">
            <label class="field-label">PROJECT MILESTONES</label>
            <div class="project--milestones-wrap">
              <div
                v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipData(projectDeliverables[index - 1]), trigger: 'hover' }"
                :class="{ 'active': projectDeliverables[index - 1].is_complete == 1, 'dots': index <= projectDeliverables.length }"
                class="milestone" v-for="index in projectDeliverables.length">
                <span class="milestone--full--deliverable">&nbsp;</span>
                <div class="milestone--task--expanson">
                  <span @click="scrollToTask(projectDeliverables[index - 1].tasks[index1 - 1].id, index)"
                    :style="{ backgroundColor: tryJSONParse(getFieldJson(projectDeliverables[index - 1].tasks[index1 - 1].taskFields, 'status').value).color }"
                    v-for="index1 in projectDeliverables[index - 1].tasks.length"
                    v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipTaskData(projectDeliverables[index - 1].tasks[index1 - 1]), trigger: 'hover', placement: 'bottom' }">&nbsp;</span>
                </div>
              </div>
            </div>
            <div class="dates">
              <span class="left">{{ projectDetail.start_date | moment("MMMM DD, YYYY") }}</span>
              <span class="right">{{ projectDetail.due_date | moment("MMMM DD, YYYY") }}</span>
            </div>
          </div>
          <div class="field-box project--detail--field"
            v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'project_detail' })"
            :key="'prj__detail__' + index">
            <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
          </div>
          <div class="project--resources">
            <div class="dropdown project--resources--title">
              <button title="Add resource" class="add-resource-button exclude-outside-click d-inline-block"
                id="add-resource-button" data-toggle="dropdown" aria-expanded="false">Resources</button>
              <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
              <div class="dropdown-menu project--resources--type--menu">
                <a class="dropdown-item" href="#" v-for="(type, i) in optionsForLinkType" :key="i"
                  @click="addResourceMenuItemClick(type, $event)"><img class="link-type-icon"
                    :src="require(`@/csmworkflow/img/${type.icon}`)"> {{ type.name }}</a>
              </div>
            </div>




            <div :class="getProjectResourcesClass">
              <div class="resource-entry resource-box" :class="userCanEditProject ? 'editable' : 'not-editable'"
                v-for="(resource, index) in _.filter(projectDetail.customFields, { field_key: 'link_url' })"
                :key="'link_url-' + index" v-if="showResourceBox(resource.value, resource.pfv_id)">
                <img class="link-type-icon"
                  :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type', resource.pfv_id)).icon}`)"
                  draggable="false">
                <div class="resource-box__url"></div>
                <a class='resource-link' v-if="resource.value" :href="resource.value"
                  @click="openCopyLinkModal(resource.value, $event, index)" target="_blank"
                  :id="`project-resource-${index}`">{{ customChildFieldValue('link_label', resource.pfv_id) ||
                    resource.value }}</a>
                <a class="resource-link" v-if="!resource.value" :href="getResourceHref(resource.value, resource.pfv_id)"
                  target="_blank" :id="`project-resource-${index}`" @click="setCookieForDownload">{{
                    customChildFieldValue('link_label', resource.pfv_id) ||
                  resource.value}}</a>
                <b-tooltip :target="`project-resource-${index}`" noninteractive triggers="manual"><i
                    class="fas fa-check" style="color:'var(--wf-primary)';"></i> Link Copied!</b-tooltip>
                <a v-b-tooltip.hover title="Edit resource" class="edit-resource-btn" href="#" v-if="userCanEditProject"
                  @click.prevent="editResource(resource)">
                  <i class="fas fa-edit"></i>
                </a>

                <div class="resource-box__notes" v-if="customChildFieldValue('link_notes', resource.pfv_id)">
                  {{ customChildFieldValue('link_notes', resource.pfv_id) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 right--side">
          <div class="project-right-side-fields">
            <div class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.engagement_manager && getSystemSetting('project__show_engagement_manager')"
              :key="'prjfields' + projectDetail.id + '-em-' + projectDetail.engagement_manager.id + '-wrapper'">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id + '-em-' + projectDetail.engagement_manager.id"
                :deliverable="projectDetail"
                :customField="{ field_key: 'engagement_manager', field_name: 'engagement_manager', label: 'Engagement Manager' }" />
            </div>

            <div class="project-engagement-manager-lock-wrapper"
              v-if="typeof projectDetail == 'object' && projectDetail.engagement_manager && getSystemSetting('project__show_engagement_manager') && getSystemSetting('project__engagement_manager_lock')">
              <button v-if="projectDetail.engagement_manager_locked" v-b-tooltip.hover
                title="Unlock to automatically set the engagement manager when the department for the project changes."
                class="btn btn-icon" @click="doToggleProjectEngagementManagerLock"><i
                  class="icomoon-lock-solid"></i></button>
              <button v-if="!projectDetail.engagement_manager_locked" v-b-tooltip.hover
                title="Lock to prevent the engagement manager from changing when the department for the project is changed"
                class="btn btn-icon" @click="doToggleProjectEngagementManagerLock"><i
                  class="icomoon-unlock"></i></button>
            </div>

            <div class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.project_lead && typeof projectDetail.project_leaders == 'undefined'">
              <ProjectCustomFields :key="`prjfields${projectDetail.id}`" :deliverable="projectDetail" :customField="{
                field_key: 'project_lead',
                field_name: 'project_lead',
                label: getSystemSetting('project__project_lead_label') || 'PROJECT LEAD'
              }" />
            </div>

            <div class="field-box"
              v-if="typeof projectDetail == 'object' && typeof projectDetail.project_leaders != 'undefined'">
              <ProjectCustomFields :key="`prjfields${projectDetail.id}`" :deliverable="projectDetail" :customField="{
                field_key: 'project_leaders',
                field_name: 'project_leaders',
                label: getSystemSetting('project__project_lead_label') || 'PROJECT LEADERS'
              }" />
            </div>


            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'project_status' })"
              :key="'prj__budget__' + Math.random()">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'project_audience' })"
              :key="'prj__budget__' + Math.random()">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'project_secondary_audience' })"
              :key="`prj__${field.field_key}__${index}`">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'account_number' })"
              :key="`prj__${field.field_key}__${index}`">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'budget' })"
              :key="'prj__budget__' + Math.random()">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box" v-if="showProjectCustomField(projectDetail, 'requisition_number')"
              v-for="(field, index) in _.filter(projectDetail.customFields, { field_key: 'requisition_number' })"
              :key="'prj__requisition__number__' + index">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, { field_key: 'manager_marketing_branding' })"
              :key="`prj__${field.field_key}__${index}`">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, { field_key: 'marketing_officer' })"
              :key="`prj__${field.field_key}__${index}`">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <div class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, { field_key: 'communications_officer' })"
              :key="`prj__${field.field_key}__${index}`">
              <ProjectCustomFields :key="'prjfields' + projectDetail.id" :deliverable="projectDetail"
                :customField="field" />
            </div>
            <b-tabs class="field-tabs" content-class="field-tab-content" fill v-model="currentTab"
              v-if="projectDetail.id && (hasContactFields() || getSystemSetting('is_chat_enabled'))">
              <b-tab class="field-tab-contacts field-box" active title="Contact" v-if="hasContactFields()">
                <ProjectContact :projectDetail="projectDetail" />
              </b-tab>
              <b-tab class="field-tab-chat" :lazy="lazyLoadChat" title="Chat" v-if="getSystemSetting('is_chat_enabled')"
                @click="turnOffLazy">
                <div class="chat-wrapper">
                  <Chat :primaryParticipantId="projectDetail.id" :primaryParticipantTitle="projectDetail.title"
                    :primaryParticipantType="0" :chatNamespace="'projectChat'"
                    :shouldRefreshMessages="currentTab == 1" />
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'open': showModalOptions, 'calendar-controls': $router.currentRoute.name == 'calendar' }"
      class="responsive-edit-modal-controls">
      <button v-b-tooltip.hover title="Duplicate Project" @click="duplicateProject()"
        class="btn delete-deliverable-btn duplicate-project-btn" v-if="userCanEditProject">
        <i class="fas fa-copy"></i>
      </button>
      <button v-b-tooltip.hover title="Merge Project" @click="mergeProject()"
        class="btn delete-deliverable-btn merge-project-btn" v-if="userCanEditProject">
        <i class="fas fa-code-merge"></i>
      </button>
      <button v-b-tooltip.hover title="Delete Project" @click="removeProject()" class="btn delete-deliverable-btn"
        v-if="userCanEditProject">
        <i class="fas fa-trash-alt"></i>
      </button>
      <button v-if="$router.currentRoute.name == 'calendar'" v-b-tooltip.hover title="Close" @click="onCloseModal"
        class="btn close-deliverable-btn">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Modal for project duplication -->
    <b-modal v-model="showDuplicateProject" id="duplicateProjectModal" size="lg"
      :title="duplicateStatus === 'completed' ? 'Duplication Complete' : 'Duplicate Project'" 
      :ok-title="duplicateStatus === 'completed' ? 'View Project' : 'Duplicate'"
      @ok="onDuplicateProject">
      
      <div v-if="duplicateBeforeTotal > 0" class="text-center">
        <p class="mt-3 duplicate-progress-count">{{ duplicateMessage }}</p>
      </div>
      <div v-else-if="duplicateStatus === 'processing' || duplicateStatus === 'pending'" class="text-center">
        <b-progress :value="duplicateProgress" class="mb-3 duplicate-progress-bar" height="20px"></b-progress>
          <div class="duplicate-progress-message">
            <span v-if="duplicateProgressCount" class="duplicate-progress-count">{{ duplicateProgressCount }}</span>
            <span class="duplicate-progress-text">{{ duplicateMessage }}</span>
            <span v-if="duplicateProgressLabel" class="duplicate-progress-label">{{ duplicateProgressLabel }}</span>
          </div>
        <p v-if="duplicateStatus === 'pending'" class="text-muted">
          <small>Another project is being duplicated. Your request will begin shortly.</small>
        </p>
      </div>

      <div v-else-if="duplicateStatus === 'completed'" class="text-center">
        <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
        <p class="mt-3 duplicate-progress-message">{{ duplicateMessage }}</p>
      </div>
      
      <div v-else-if="duplicateStatus === 'failed'" class="text-center">
        <i class="fas fa-times-circle text-danger" style="font-size: 3rem;"></i>
        <p class="mt-3" style="font-weight: bold;">A system error occurred. Duplication failed.</p>
        <p class="text-muted">
          An error notification has been sent to Pattern Interactive.
        </p>
      </div>

      <div v-else>
        <b-form>
          <b-form-group label="New Project Name" label-class="font-weight-500" label-for="newProjectTitle" class="mb-4">
            <b-form-input v-model="duplicateOptions.title" id="newProjectTitle" 
              :state="duplicateNameExists ? false : null" @input="checkDuplicateName">
            </b-form-input>
            <b-form-invalid-feedback v-if="duplicateNameExists">
              {{ !duplicateOptions.title.trim() ? 'Project name is required' : 'A project with this name already exists' }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Duplication Options" label-class="font-weight-500" class="mb-4">
            
            <!-- Project Detail Category -->
            <div class="mb-4">
              <h6 class="text-muted mb-3">Project</h6>
              <div class="ml-3">
                <b-form-checkbox v-model="duplicateOptions.department">
                  Department
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.deadline">
                  Deadline
                </b-form-checkbox>

                <b-form-checkbox v-model="duplicateOptions.projectDetail">
                  Project Detail
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.resources">
                  Resources
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.engagementManager">
                  Engagement Manager
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.projectLead">
                  Project Lead
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.status">
                  Status
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.audience">
                  Audience
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.budget">
                  Budget
                </b-form-checkbox>
                
                <b-form-checkbox v-model="duplicateOptions.requisitionNumber">
                  Requisition number
                </b-form-checkbox>
                
              </div>
            </div>
            
            <!-- Deliverables Category -->
            <div class="mb-4">
              <h6 class="text-muted mb-3">Deliverables</h6>
              <div class="ml-3">
                <b-form-checkbox v-model="duplicateOptions.deliverables" :disabled="deliverableCount === 0">
                	Copy <template v-if="deliverableCount == 1">
                	{{projectDeliverables.length}} Deliverable</template>
                	<template v-else="">{{ deliverableCount }} Deliverables</template><br/>(does not include media calls or social media posts)
                </b-form-checkbox>

                <b-form-checkbox v-model="duplicateOptions.socialMediaPosts" :disabled="!duplicateOptions.deliverables || (projectDeliverables ? projectDeliverables.length : 0) === 0">
                  Include Social Media Posts
                </b-form-checkbox>

                <b-form-checkbox v-if="false" v-model="duplicateOptions.deliverableDueDates" :disabled="!duplicateOptions.deliverables || (projectDeliverables ? projectDeliverables.length : 0) === 0">
                  Copy Deliverable Due Dates
                </b-form-checkbox>

                
                <b-form-checkbox v-model="duplicateOptions.taskUsers" :disabled="!duplicateOptions.deliverables || (projectDeliverables ? projectDeliverables.length : 0) === 0">
                  Copy Task Users
                </b-form-checkbox>
                
                <b-form-checkbox v-if="false" v-model="duplicateOptions.taskDueDates" :disabled="!duplicateOptions.deliverables || (projectDeliverables ? projectDeliverables.length : 0) === 0">
                  Copy Task Due Dates
                </b-form-checkbox>

                <b-form-checkbox v-model="duplicateOptions.taskNotes" :disabled="!duplicateOptions.deliverables || (projectDeliverables ? projectDeliverables.length : 0) === 0">
                  Copy Task Notes
                </b-form-checkbox>
              </div>
            </div>
            
            <!-- Ready to Duplicate -->
            <div class="pt-3 border-top" style="margin-bottom: -1em;">
              <b-form-checkbox v-model="duplicateOptions.readyToDuplicate" class="font-weight-bold" v-if="projectDetail">
                I am ready to duplicate project '{{projectDetail.title}}'
              </b-form-checkbox>
            </div>
            
          </b-form-group>
        </b-form>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()" v-if="duplicateStatus !== 'processing'">
          {{ duplicateStatus === 'completed' ? 'Close' : 'Cancel' }}
        </b-button>
        <b-button variant="success" @click="ok()" 
          :disabled="duplicateStatus === 'processing' || duplicateStatus === 'failed' || (duplicateStatus === 'completed' && !duplicateProjectNumber) || (!duplicateStatus && (duplicateNameExists || !duplicateOptions.readyToDuplicate))">
          {{ duplicateStatus === 'completed' ? 'View Project' : 'Duplicate' }}
        </b-button>
      </template>
    </b-modal>

    <!-- Modal for project merging -->
    <b-modal v-model="showMergeProject" id="mergeProjectModal"
      :title="mergeSuccess ? 'Merge Successful' : 'Merge Project'" :ok-title="mergeSuccess ? 'Go Now' : 'Merge'"
      @ok="onMergeProject">
      <div v-if="!mergeSuccess && !mergeLoading" class="form-group">
        <label>Select project to merge into</label>
        <multiselect v-if="false" v-model="targetMergeProject" :options="projectsOption" label="name" track-by="id"
          :allow-empty="false" :show-labels="true" placeholder="Pick a project" aria-label="pick a project">
        </multiselect>

        <multiselect
          ref="deliverableProjects"
          v-model="targetMergeProject"
          :close-on-select="true"
          :options="projectsOption"
          :show-labels="true"
          :multiple="false"
          :taggable="false"
          label="name"
          track-by="id"
          :allow-empty="false"
          group-label="group"
          group-values="entries"
          :group-select="false"
          placeholder="Pick a project"
          aria-label="pick a project"
          @input="onProjectSelected(targetMergeProject)"
        ></multiselect>






      </div>
      <div v-if="mergeLoading" class="text-center">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
        <p class="mt-3">Merging projects...</p>
      </div>
      <div v-if="mergeSuccess" class="text-center">
        <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
        <p class="mt-3">Projects merged successfully!</p>
        <p>Redirecting to project page in <strong>{{ mergeCountdown }}</strong> seconds...</p>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="success"
          @click="ok()" :disabled="(!mergeSuccess && !targetMergeProject.id) || mergeLoading">
          <b-spinner small v-if="mergeLoading"></b-spinner>
          {{ mergeLoading ? 'Merging...' : (mergeSuccess ? 'Go Now' : 'Merge') }}
        </b-button>
      </template>
    </b-modal>

    <!-- Modal for project deletion -->
    <b-modal v-model="showRemoveProject" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveProject"
      ok-title="Yes, Delete">
      <p>Are you sure you want to delete this project?</p>
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="createProjectLinkModal" title="New Resource / Link"
      @shown="focusLinkModal">
      <CreateProjectLinkModal ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" :is-file="editLinkIsFile"
        :resource-parent="'project'" />
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="editProjectLinkModal" title="Update Resource / Link"
      @shown="focusEditLinkModal">
      <EditProjectLinkModal ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" />
    </b-modal>
    <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
      <LinkCopyLinkModal :linkUrl="linkCopyModalValue" />
    </b-modal>
  </div>
</template>

const RECENT_PROJECTS_KEY = 'recentProjects';
const MAX_RECENT = 10;


<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import Vue from 'vue';
import vueFilePond from "vue-filepond";
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Format from "../../utility/Format";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import ProjectCustomFields from "../common/ProjectCustomField";
import Chat from "./Chat";
import CreateProjectLinkModal from "./CreateProjectLinkModal";
import EditProjectLinkModal from "./EditProjectLinkModal";
import ProjectContact from "./ProjectContact";
import ProjectDepartments from "./ProjectDepartments";

const VueFilePond = vueFilePond();

import "filepond/dist/filepond.min.css";

export default {
  props: ['projectDeliverables'],
  data() {
    return {
      Format,
      currentTab: 0,
      dateSelected: false,
      showModalOptions: false,
      renderCount: 1,
      editTitle: false,
      showDuplicateProject: false,
      showMergeProject: false,
      showRemoveProject: false,
      showRemoveResource: false,
      addResourceFlag: false,
      lazyLoadChat: true,
      linkUrl: null,
      linkLabel: null,
      linkNotes: null,
      linkType: null,
      completedCount: [],
      currentDotPosition: [],
      filepond: [],
      editLinkIsFile: false,
      editProjectDueDateBg: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},
      targetMergeProject: {},
      mergeCountdown: 5,
      mergeSuccess: false,
      mergeProjectNumber: null,
      mergeLoading: false,
      duplicateProgress: 0,
      duplicateMessage: '',
      duplicateBeforeTotal: 0,
      duplicateStatus: '',
      duplicateProgressDetails: null,
      duplicateProjectId: null,
      duplicateNameExists: false,
      duplicateOptions: {
        title: '',
        department: true,
        deadline: false,
        projectDetail: true,
        resources: true,
        engagementManager: true,
        projectLead: true,
        status: false,
        audience: true,
        budget: true,
        requisitionNumber: false,
        deliverables: true,
        deliverableDueDates: false,
        taskNotes: false,
        taskUsers: false,
        taskDueDates: false,
        socialMediaPosts: false,
        readyToDuplicate: false
      },
    };
  },
  components: {
    'vuejs-datepicker': Datepicker,
    Chat,
    ProjectContact,
    ProjectCustomFields,
    ProjectDepartments,
    Autocomplete,
    EditProjectLinkModal,
    CreateProjectLinkModal,
    VueFilePond,
    LinkCopyLinkModal,
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  recentProjectIds (state, getters) {
  	  	return getters['recentProjectIds']
  	  }
  	 }),
    ...mapGetters([
      "allDepartments",
      "systemSettings",
      "getSystemSetting",
      "userAbilities",
      "projectDetail",
      "allCustomFields",
      "allProjects",
      "allProjectDeliverablesPaginationData",
    ]),
    deliverableCount() {
      if (this.allProjectDeliverablesPaginationData && this.allProjectDeliverablesPaginationData.total) {
        return this.allProjectDeliverablesPaginationData.total;
      }
      return this.projectDeliverables ? this.projectDeliverables.length : 0;
    },

    projectsOption() {
    	const selectedId = this.projectDetail.id ?? null;

       // ── Branch: user can manage only their own projects ──────────
       if (!this.userAbilities.accessAllProjects) {
         if (!this.userManageProjects) return [];


         const mapped = this.userManageProjects.map(elem => ({
           id: elem.id,
           name: elem.title,
           engagement_manager: elem.engagement_manager,
           project_lead: elem.project_lead,
         }));


       }


       // ── Branch: user has access to all projects ──────────────────
       if (!this.allProjects) return [];

       // Map all projects into a flat shape
       // const mapped = this.allProjects.map(elem => ({
       //   id: elem.id,
       //   name: elem.title,
       //   engagement_manager: elem.engagement_manager,
       //   project_lead: elem.project_lead,
       // }));


       const mapped = this.allProjects.map(elem => {
          const dueDate = elem.due_date ? this.$moment(elem.due_date).format('MMM YYYY') : 'No Date';
         return {
           id: elem.id,
           name: `${elem.title} (${elem.project_number}) - Due: ${dueDate}`,
           engagement_manager: elem.engagement_manager,
           project_lead: elem.project_lead,
         };
       });




       // ── Selected group ────────────────────────────────────────────
       const selectedEntries = selectedId
         ? mapped.filter(p => p.id === selectedId)
         : [];

       // ── Recent group: everyone except the selected project ────────
       const rest = mapped.filter(p => p.id !== selectedId);

       // Split into "has a recent rank" vs "never visited"
       const recentIndexOf = p => this.recentProjectIds.indexOf(p.id);
       const inRecent    = rest.filter(p => recentIndexOf(p) !== -1);
       const notInRecent = rest.filter(p => recentIndexOf(p) === -1);

       // Sort by recency position, then alphabetically for the tail
       inRecent.sort((a, b) => recentIndexOf(a) - recentIndexOf(b));
       notInRecent.sort((a, b) => a.name.localeCompare(b.name));

       const recentEntries = [...inRecent, ...notInRecent];

       return [
         { group: 'Selected', entries: selectedEntries },
         { group: 'Recent',   entries: recentEntries   },
       ];
     },

     /*
    projectsOption() {
      if (this.userAbilities.accessAllProjects) {
        if (this.allProjects) {
          let projectArr = [];
          this.allProjects.filter(elem => elem.id != this.projectDetail.id).forEach(elem => {
            const dueDate = elem.due_date ? this.$moment(elem.due_date).format('MMM YYYY') : 'No Date';
            projectArr.push({ 
              id: elem.id, 
              name: `${elem.title} (${elem.project_number}) - Due: ${dueDate}`
            });
          });
          return projectArr;
        }
      } else {
        if (this.userManageProjects) {
          let projectArr = [];
          this.userManageProjects.filter(elem => elem.id != this.projectDetail.id).forEach(elem => {
            const dueDate = elem.due_date ? this.$moment(elem.due_date).format('MMM YYYY') : 'No Date';
            projectArr.push({ 
              id: elem.id, 
              name: `${elem.title} (${elem.project_number}) - Due: ${dueDate}`
            });
          });
          return projectArr;
        }
      }
    },
    */

    // so that we can use lodash in the template
    _() {
      return _;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    getProjectResourcesClass() {
      let className = "project--resources--content field-box__content";
      let hasResources = false;
      if (this.projectDetail) {
        if (this.projectDetail.customFields) {
          for (var i = 0; i < this.projectDetail.customFields.length; i++) {
            if (this.projectDetail.customFields[i].field_key == 'link_url') {
              hasResources = true;
            }
          }
          if (hasResources) {
            className += " has-entries";
          }
        }
      }
      return className;
    },
    userCanEditProject() {
      const userId = localStorage.getItem("userId");
      const project = this.projectDetail;

      if (this.userAbilities.accessAllProjects) {
        return this.userAbilities.editProject;
      }

      let isManager = false;
      if (project.engagement_manager instanceof Object) {
        isManager = userId == project.engagement_manager.id;
      } else {
        isManager = userId == project.engagement_manager;
      }

      return (this.userAbilities.editProject && isManager);
    },
    calculateEndDate() {
      let latestDueDate = null;

      if (this.projectDeliverables && this.projectDeliverables.length > 0) {
        this.projectDeliverables.forEach(deliverable => {
          if (deliverable.tasks && deliverable.tasks.length > 0) {
            deliverable.tasks.forEach(task => {
              const dueDateField = task.taskFields.filter(x => x.field_key == 'due_date')[0];
              let dueDateFieldValue = null;
              if (dueDateField && dueDateField.value) {
                dueDateFieldValue = Vue.moment(dueDateField.value);
              }
              if (dueDateFieldValue && (!latestDueDate || latestDueDate.isBefore(dueDateFieldValue))) {
                latestDueDate = Vue.moment(dueDateFieldValue);
              }
            });
          }
        });
      }

      return latestDueDate;
    },
    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
    },
    duplicateProgressCount() {
      if (!this.duplicateProgressDetails || !this.duplicateProgressDetails.total) {
        return null;
      }
      const completed = this.duplicateProgressDetails.completed ?? 0;
      const total = this.duplicateProgressDetails.total ?? 0;
      return `${completed}/${total}`;
    },
    duplicateProgressLabel() {
      if (!this.duplicateProgressDetails || !this.duplicateProgressDetails.label) {
        return null;
      }
      return this.duplicateProgressDetails.label;
    },
  },
  methods: {
    ...mapActions([
      "updateFieldValue",
      "updateProjectFieldValue",
      "fetchProjectDeliverable",
      "highlightTask",
      "updateDueDate",
      "toggleProjectEngagementManagerLock",
    ]),
    ...mapActions({
		    getRecentProjectIds() {
		      try {
		        return JSON.parse(localStorage.getItem(RECENT_PROJECTS_KEY)) || [];
		      } catch {
		        return [];
		      }
		    },
		    updateRecentProjects(projectId) {
		      if (!projectId) return;
		      const recent = this.getRecentProjectIds().filter(id => id !== projectId);
		      recent.unshift(projectId);                        // most recent first
		      localStorage.setItem(
		        RECENT_PROJECTS_KEY,
		        JSON.stringify(recent.slice(0, MAX_RECENT))
		      );
		    },
		  }
    ),
    ...mapMutations([
      "setProjectDetail"
    ]),
    hasContactFields() {
      const contactCustomFields = _.filter(this.projectDetail.projectCustomFields, { field_type: 'contacts' });
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },
    turnOffLazy() {
      // lazyLoadChat = true when modal is opened, no chat related api calls
      // Chat tab is clicked once, chat api calls, roomInfo and messages are loaded
      // turn off lazy loading to avoid api calls whenever tab is clicked again
      this.lazyLoadChat = false;
    },
    showProjectCustomField(project, fieldKey) {
      const projectCustomFieldArray = this._.filter(project.projectCustomFields, { field_key: fieldKey });
      if (Array.isArray(projectCustomFieldArray) && projectCustomFieldArray.length) {
        // array exist, is not empty
        return true;
      }
      return false;
    },

    doToggleProjectEngagementManagerLock() {
      let payload = {
        projectId: this.projectDetail.id,
      };
      this.toggleProjectEngagementManagerLock(payload);
    },




    projectDueDateClick() {
      if (this.dateSelected) {
        this.editProjectDueDateBg = false;
      } else {
        this.editProjectDueDateBg = true;
      }
      this.dateSelected = false;
    },
    projectDueDateSelected() {
      this.editProjectDueDateBg = false;
      this.dateSelected = true;
    },
    findPosition() {
      if (this.$refs.refDatepickerWrapper.getBoundingClientRect().y > 315) {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "-282px");
      } else {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "unset");
      }
    },
    updateProjectDueDate() {
      this.updateDueDate({ projectData: this.projectDetail }).then(() => {
      })
    },
    onToday() {
      this.projectDetail.due_date = this.$moment().format("YYYY-MM-DD H:m:s");
      this.$refs.projectDueDate.close();
      this.updateProjectDueDate();
    },
    resetDeadline() {
      this.projectDetail.due_date = null
      this.updateProjectDueDate();
    },
    customDateFormat(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD MMM, YYYY");
    },
    scrollToDeliverable(deliverableId, dIndex) {
      const id = 'project__deliverable__' + deliverableId;
      const yOffset = -95;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    scrollToTask(taskId, dIndex) {
      const id = "task__title__" + taskId;
      const taskElOffset = $(".task-fields .field-block ." + id).offset();
      this.highlightTask(taskId);
      if (taskElOffset.top == 0) {
        this.$root.$emit('bv::toggle::collapse', "task-listing-collapse-" + (dIndex - 1));
      } else {
        this.$nextTick(() => {
          const taskElOffset2 = $(".task-fields .field-block ." + id).offset();
          window.scrollTo({ top: taskElOffset2.top - 195, behavior: 'smooth' });
        });
      }
    },
    getFieldJson(fieldArray, fieldKey) {
      let field
      field = _.filter(fieldArray, { field_key: fieldKey })
      if (field) {
        return field[0]
      }
    },
    tipTaskData(taskData) {
      let taskTitle = taskData.title
      let taskStatusJson = this.getFieldJson(taskData.taskFields, 'status')
      let taskStatus = this.tryJSONParse(taskStatusJson.value)
      return taskStatus.name + ' : ' + taskTitle
    },
    tipData(deliverableData) {
      return deliverableData.due_date ? Vue.moment(deliverableData.due_date).format("MMMM DD, YYYY") : Vue.moment(deliverableData.created_at).format("MMMM DD, YYYY") + '<br>' + deliverableData.title
    },
    updateProjectTitle() {
      this.projectDetail.title = Format.replaceLineBreaks(this.projectDetail.title, " ");
      this.updateProjectFieldValue(this.projectDetail).then(() => {
        this.fetchProjectDeliverable(1);
      });
    },
    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
    },
    showAddResource() {
      this.addResourceFlag = true;
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    getResourceHref(url, parent_id) {
      let label = this.customChildFieldValue('link_label', parent_id);
      let fileId = this.customChildFieldValue('file_id', parent_id);
      if (url == null && fileId != null && label) {
        return `${this.apiUrl}downloadFileProject/${this.projectDetail.id}/${fileId}`;
      }
      return "";
    },
    openCopyLinkModal(link, e, i) {
      if (!link.includes("\\")) {
        return;
      }
      e.preventDefault();
      this.copyLink(link, i);
    },
    async copyLink(link, resourceId) {
      clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
      Object.keys(this._.filter(this.projectDetail.customFields, { field_key: 'link_url' })).forEach(x => {
        if (x == resourceId) return;
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + x);
      })

      const navPer = await navigator.permissions.query({ name: "clipboard-write" });
      if (navPer.state == "granted" || navPer.state == "prompt") {
        try {
          await navigator.clipboard.writeText(link);
        } catch {
          console.error("clipboard API error. Cannot copy to clipboard.");
          this.legacyCopyMethod(link);
        }
      } else {
        this.legacyCopyMethod(link);
      }

      this.$root.$emit('bv::show::tooltip', 'project-resource-' + resourceId);
      this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + resourceId);
      }, 2000);
    },
    legacyCopyMethod(link) {
      let tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
      tempInput.value = link;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },

    showResourceBox(url, parent_id) {
      let fileId = this.customChildFieldValue('file_id', parent_id);
      return (url != null || fileId != null);
    },
    customChildField(key, parent_id) {
      if (this.projectDetail.customFields) {
        let obj = _.filter(this.projectDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj.length > 0) {
          // lets add it to the
          return obj;
        } else {
          if (key == 'file_id') return null;
          if (key == 'link_type') return [];
          // return the global version of the custom field...
          let field = _.filter(this.allCustomFields, { field_key: key });
          obj = {};
          obj.id = null;
          obj.parent_id = this.projectDetail.customFields[index].id;
          obj.project_id = this.projectDetail.customFields[index].project_id;
          obj.editing = false;
          obj.field_id = field[0].id;
          obj.field_key = field[0].field_key;
          obj.field_parent_id = field[0].parent_id;
          obj.field_type = field[0].field_type;
          obj.note = field[0].note;
          obj.value = null;
          obj.label = field[0].label;
          obj.value_set = field[0].value_set;
          obj.updated_at = this.projectDetail.customFields ? this.projectDetail.customFields[index].updated_at : null;
          return [obj];
        }
      }
      return [];
    },
    customChildFieldValue(key, parent_id) {
      if (this.projectDetail.customFields) {
        let obj = _.filter(this.projectDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj.length > 0) {
          return obj[0].value;
        } else {
          return null;
        }
      }
      return null;
    },
    editResource(resource) {
      this.linkUrl = resource;
      let label = this.customChildField('link_label', resource.pfv_id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes = this.customChildField('link_notes', resource.pfv_id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type = this.customChildField('link_type', resource.pfv_id);
      if (type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id: null,
          field_id: 37,
          project_field_id: _.filter(this.projectDetail.customFields, { field_key: 'link_type' })[0]?.projectFieldId,
          parent_field_id: 20,
          field_key: "link_type",
          field_type: "select",
          parent_id: null,
          project_id: this.projectDetail.projectId,
          value: 1
        };
      }
      let fileId = this.customChildField('file_id', resource.pfv_id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editProjectLinkModal");
    },
    addResource(typeId = 1, modalId) {
      // if(!this.userAbilities.editMediaCall || this.projectDetail.permissions.viewOnly) return;
      if (!this.userCanEditProject) return;
      this.linkUrl = {
        id: null,
        field_id: 20,
        project_field_id: _.filter(this.projectDetail.customFields, { field_key: 'link_url' })[0].projectFieldId,
        parent_field_id: null,
        field_key: "link_url",
        field_type: "text",
        parent_id: null,
        project_id: this.projectDetail.projectId,
        value: null
      };
      this.linkLabel = {
        id: null,
        field_id: 21,
        project_field_id: _.filter(this.projectDetail.customFields, { field_key: 'link_label' })[0].projectFieldId,
        parent_field_id: 20,
        field_key: "link_label",
        field_type: "text",
        parent_id: null,
        project_id: this.projectDetail.projectId,
        value: null
      };
      this.linkNotes = {
        id: null,
        field_id: 22,
        project_field_id: _.filter(this.projectDetail.customFields, { field_key: 'link_notes' })[0].projectFieldId,
        parent_field_id: 20,
        field_key: "link_notes",
        field_type: "text",
        parent_id: null,
        project_id: this.projectDetail.projectId,
        value: null
      };
      this.linkType = {
        id: null,
        field_id: 37,
        project_field_id: _.filter(this.projectDetail.customFields, { field_key: 'link_type' })[0]?.projectFieldId,
        parent_field_id: 20,
        field_key: "link_type",
        field_type: "select",
        parent_id: null,
        project_id: this.projectDetail.projectId,
        value: typeId
      }
      this.$bvModal.show(modalId);
    },
    addResourceMenuItemClick(type, e) {
      e.preventDefault();
      let modalId = "createProjectLinkModal";
      if (type.slug == "file") {
        this.editLinkIsFile = true;
      } else {
        this.editLinkIsFile = false;
      }
      this.addResource(type.id, modalId);
    },
    removeProject() {
      this.showRemoveProject = true;
    },
    async mergeProject() {
      let that = this;
      await this.$store.dispatch('fetchAllProjects').then(() => {
        that.mergeSuccess = false;
        that.mergeCountdown = 5;
        that.mergeLoading = false;
        that.showMergeProject = true;
    	});

    },
    async duplicateProject() {
      // Only reset if no active job exists
      if (this.duplicateStatus !== 'processing') {
        this.duplicateStatus = '';
        this.duplicateProgress = 0;
        this.duplicateMessage = '';
        this.duplicateProgressDetails = null;
        this.duplicateProjectNumber = null;
        await this.$store.dispatch('fetchAllProjects');
        this.duplicateOptions.title = this.generateNewProjectTitle();
        this.duplicateNameExists = false;
      }
      this.showDuplicateProject = true;
    },
    generateNewProjectTitle() {
      let newTitle = this.projectDetail.title;
      
      // Remove ESR codes like (ESR-100745)
      newTitle = newTitle.replace(/\s*\(ESR-\d+\)\s*/g, ' ').trim();
      
      // Match single or range years in many formats
      const pattern = /\b((?:20)?\d{2})(?:\s?[-–\/]\s?((?:20)?\d{2}))?\b/g;
      
      const updatedTitle = newTitle.replace(pattern, (match, firstPart, secondPart) => {
        // If there's a range (e.g. 2021/2022)
        if (secondPart) {
          // Find separator (-, /, or –)
          const sepMatch = match.match(/[-–\/]/);
          const sep = sepMatch ? sepMatch[0] : '-';
          
          // Parse years and add 1 to each
          const firstYear = firstPart.length === 2 ? 2000 + parseInt(firstPart) : parseInt(firstPart);
          const secondYear = secondPart.length === 2 ? 2000 + parseInt(secondPart) : parseInt(secondPart);
          
          // Preserve formatting (2-digit or 4-digit)
          const firstOut = firstPart.length === 2 ? (firstYear + 1).toString().slice(-2) : firstYear + 1;
          const secondOut = secondPart.length === 2 ? (secondYear + 1).toString().slice(-2) : secondYear + 1;
          return `${firstOut}${sep}${secondOut}`;
        }
        
        // Single year only - add 1 to the found year
        const year = firstPart.length === 2 ? 2000 + parseInt(firstPart) : parseInt(firstPart);
        return firstPart.length === 2 ? (year + 1).toString().slice(-2) : year + 1;
      });
      
      return this.getUniqueProjectTitle(updatedTitle === newTitle ? newTitle : updatedTitle);
    },
    getUniqueProjectTitle(baseTitle) {
      const existingTitles = this.allProjects ? this.allProjects.map(p => p.title.toLowerCase()) : [];
      const normalizeTitle = (title) => title.toLowerCase().replace(/\s+/g, '');
      
      // Check if title already has (copy xx) pattern and extract base
      let cleanTitle = baseTitle;
      let startCounter = 1;
      const copyMatch = baseTitle.match(/^(.+?)\s*\(copy\s*(\d+)?\)\s*$/i);
      if (copyMatch) {
        cleanTitle = copyMatch[1].trim();
        startCounter = copyMatch[2] ? parseInt(copyMatch[2]) + 1 : 2;
      }
      
      // First check if the clean title is already unique
      const normalizedBase = normalizeTitle(cleanTitle);
      if (!existingTitles.some(title => title.replace(/\s+/g, '') === normalizedBase)) {
        return cleanTitle;
      }
      
      // If clean title exists, try with (copy)
      let newTitle = cleanTitle + ' (copy)';
      const normalizedCopy = normalizeTitle(newTitle);
      if (!existingTitles.some(title => title.replace(/\s+/g, '') === normalizedCopy)) {
        return newTitle;
      }
      
      // Try with (copy startCounter), (copy startCounter+1)
      let counter = startCounter;
      let normalizedNew;
      do {
        newTitle = `${cleanTitle} (copy ${counter})`;
        normalizedNew = normalizeTitle(newTitle);
        counter++;
      } while (existingTitles.some(title => title.replace(/\s+/g, '') === normalizedNew));
      
      return newTitle;
    },
    checkDuplicateName() {
      const trimmedTitle = this.duplicateOptions.title.trim();
      if (!trimmedTitle) {
        this.duplicateNameExists = true;
        return;
      }
      const existingTitles = this.allProjects ? this.allProjects.map(p => p.title.toLowerCase().replace(/\s+/g, '')) : [];
      this.duplicateNameExists = existingTitles.includes(trimmedTitle.toLowerCase().replace(/\s+/g, ''));
    },
    onConfirmRemoveProject() {
      if (this.projectDetail.id) {
        let that = this;
        let projectId = this.projectDetail.id;
        this.$store.dispatch("removeProject", { projectId: projectId }).then(function () {
          that.$store.dispatch('manageUndoActivation', 'Project removed.');
          if (that.$route.path.includes('/my-projects')) {
            that.$router.push('/my-projects');
          } else {
            that.$router.push('/project');
          }
        });
      }
    },
    onMergeProject(bvModalEvent) {
      if (this.mergeSuccess) {
        this.showMergeProject = false;
        window.location.href = `/project/${this.mergeProjectNumber}`;
        return;
      }

      bvModalEvent.preventDefault()

      if (this.targetMergeProject.id) {
        this.mergeLoading = true;
        this.$store.dispatch('mergeProjects', {
          source_project_id: this.projectDetail.id,
          target_project_id: this.targetMergeProject.id
        }).then(response => {
          this.mergeLoading = false;
          if (response.data.success) {
          	this.$store.dispatch('addRecentProject', this.targetMergeProject.id);
            this.mergeSuccess = true;
            this.mergeProjectNumber = response.data.project_number;
            this.startCountdown();
          }
        }).catch(() => {
          this.mergeLoading = false;
        });
      }
    },
    onDuplicateProject(bvModalEvent) {
      if (this.duplicateStatus === 'completed' && this.duplicateProjectNumber) {
        window.location.href = `/project/${this.duplicateProjectNumber}`;
        return;
      }
      
      bvModalEvent.preventDefault();

      this.duplicateStatus = 'processing';
      this.duplicateProgress = 0;
      this.duplicateMessage = '';
      this.duplicateProgressDetails = null;
      
      // Start listening for progress events
      this.$root.$on('duplicationJobProgress', this.handleJobProgress);

      this.$root.$on('duplicationJobInQueue', this.handleJobInQueue);


      
      this.$store.dispatch('duplicateProject', {
        projectId: this.projectDetail.id,
        ...this.duplicateOptions
      }).then(response => {
        if (response.data.success) {
          this.duplicateJobKey = response.data.job_key;
          
          // Check if it's a silent fail (WebSocket not running)
          if (response.data.silent_fail) {
            this.duplicateStatus = 'failed';
            this.duplicateMessage = 'WebSocket server is not running. An error notification has been sent to Pattern Interactive.';
            this.$root.$off('duplicationJobProgress', this.handleJobProgress);
            return;
          }
          
          // Show queue position message
          if (response.data.queue_message) {
            this.duplicateMessage = response.data.queue_message;
          }
          
          // Trigger global monitoring (single EventSource in App.vue)
          this.$root.$emit('startGlobalDuplicationMonitoring', {
            jobKey: response.data.job_key,
            queuePosition: typeof response.data.queue_position === 'number' ? response.data.queue_position : null
          });
        } else {
          this.duplicateStatus = 'failed';
          this.duplicateMessage = response.data.message || 'Duplication failed';
          // Job failed, stop listening
          this.$root.$off('duplicationJobProgress', this.handleJobProgress);
        }
      }).catch(error => {
        this.duplicateStatus = 'failed';
        this.duplicateMessage = error.response?.data?.message || 'Duplication failed';
        // Job failed, stop listening
        this.$root.$off('duplicationJobProgress', this.handleJobProgress);
      });
    },
    handleJobInQueue(data) {
    	console.log("handleJobInQueue", data);
    	if (data.jobKey !== this.duplicateJobKey) {
    		 return;
    	}
  		this.duplicateMessage = data.queue_message;
  		this.duplicateBeforeTotal = data.queue_before;
    },
    handleJobProgress(data) {
      // Only handle progress for this modal's job
      if (data.jobKey !== this.duplicateJobKey) {
        return;
      }
      
      if (data.status === 'pending') {
        // Keep showing queue message for pending status
        this.duplicateStatus = 'processing';
        this.duplicateProgress = 0;
        this.duplicateProgressDetails = null;
        // Don't override the queue message
      } else if (data.status === 'processing') {
        this.duplicateStatus = 'processing';
        this.duplicateProgress = Math.round(data.progress || 0);
        this.duplicateMessage = data.message || 'Processing...';
        this.duplicateProgressDetails = data.progress_details || null;
      } else if (data.status === 'completed') {
        this.duplicateStatus = 'completed';
        this.duplicateProgress = 100;
        this.duplicateMessage = data.message || 'Project duplicated successfully!';
        this.duplicateProgressDetails = null;
        this.duplicateProjectNumber = data.project_number;
        this.$store.dispatch('fetchAllProjects');
        // Remove beforeunload warning since job is complete
        this.removeBeforeUnloadListener();
        // Stop listening
        this.$root.$off('duplicationJobProgress', this.handleJobProgress);
      } else if (data.status === 'failed') {
        this.duplicateStatus = 'failed';
        this.duplicateMessage = data.error || 'Duplication failed';
        this.duplicateProgressDetails = null;
        // Remove beforeunload warning since job is no longer processing
        this.removeBeforeUnloadListener();
        // Stop listening
        this.$root.$off('duplicationJobProgress', this.handleJobProgress);
      }
    },
    handleBeforeUnload(e) {
      if (this.duplicateStatus === 'processing') {
        e.preventDefault();
        e.returnValue = 'Project duplication is in progress. The job will continue in the background. Are you sure you want to leave?';
        return e.returnValue;
      }
    },
    removeBeforeUnloadListener() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    startCountdown() {
      const interval = setInterval(() => {
        this.mergeCountdown--;
        if (this.mergeCountdown <= 0) {
          clearInterval(interval);
          this.showMergeProject = false;
          window.location.href = `/project/${this.mergeProjectNumber}`;
        }
      }, 1000);
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },
    onCloseModal() {
      this.$bvModal.hide("editProjectModal");
      if (this.$router.currentRoute.name == 'calendar') {
        this.$root.$emit('re__fetch__calendar__data', this.deliverableDetail);
      }
    },
    activateTitleField() {
      if (!this.userCanEditProject) return;
      let that = this
      this.editTitle = true;
      setTimeout(function () {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },



    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    editProjectDueDateClick() {
      if (!this.editProjectDueDateBg) {
        this.editProjectDueDateBg = true;
      }
    },
    editProjectDatePickerClickOutside() {
      this.editProjectDueDateBg = false;
    },
  },
  watch: {
    projectDeliverables: {
      handler(newVal) {

      	if (this.projectDetail) {
      		if (this.projectDetail.id) {
      			this.$store.dispatch('addRecentProject', this.projectDetail.id);
      		}
      	}

        const hasDeliverables = newVal && newVal.length > 0;
        if (!hasDeliverables) {
          this.duplicateOptions.deliverables = false;
          this.duplicateOptions.deliverableDueDates = false;
          this.duplicateOptions.taskNotes = false;
          this.duplicateOptions.taskUsers = false;
          this.duplicateOptions.taskDueDates = false;
          this.duplicateOptions.socialMediaPosts = false;
        } else {
          this.duplicateOptions.deliverables = true;
        }
      },
      immediate: true
    },
    'duplicateOptions.deliverables'(newVal) {
      if (!newVal) {
        this.duplicateOptions.deliverableDueDates = false;
        this.duplicateOptions.taskNotes = false;
        this.duplicateOptions.taskUsers = false;
        this.duplicateOptions.taskDueDates = false;
        this.duplicateOptions.socialMediaPosts = false;
      }
    },
    showDuplicateProject(isOpen) {
      if (isOpen) {
        this.$root.$emit('duplicateModalOpened');
        // Reconnect to progress events when modal opens
        if (this.duplicateJobKey) {
          this.$root.$on('duplicationJobProgress', this.handleJobProgress);
        }
      } else {
        this.$root.$emit('duplicateModalClosed');
        // Don't disconnect - let the modal keep receiving updates even when closed
        // This ensures it has the latest state when reopened
      }
    }
  },
  mounted() {
    $('#editProjectModal .modal-content').removeAttr('tabindex');
    

    // Add beforeunload warning
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    // let that = this;
    // this.$nextTick(function () {
    //   setTimeout(function () {
    //     if (that.projectDetail.id !== undefined) {
    //       // call api to read all alerts after 10 seconds
    //       that.$store.dispatch(
    //         'makeAllRelatedAlertRead',
    //         {
    //           groupedModelId: that.projectDetail.id
    //         }
    //       );
    //     }
    //   }, 10000);
    // });

  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('duplicationJobProgress', this.handleJobProgress);
    // Remove beforeunload listener
    this.removeBeforeUnloadListener();
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.project--detail--field {
  margin-top: 50px;
}

.editable-project-due-date {
  .vdp-datepicker {
    display: inline-block;

    .day__month_btn,
    .cell,
    .month__year_btn,
    .vdp-datepicker__calendar header {
      color: var(--db-span-hover-black);
    }

    input {
      background: transparent;
      color: var(--db-date-picker);
      font-size: 22px;
      border: unset;
      cursor: pointer;

      &::placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
        opacity: 1;
      }

      &:-ms-input-placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
      }

      &::-ms-input-placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
      }
    }
  }
}

.edit-deliverable-modal .nav-tabs .nav-item .nav-link.active {
  border: unset;
  background: linear-gradient(to bottom, var(--wf-secondary) 0%, var(--edit-deliverable-modal-edit-project-modal-field-header-lgbg) 86%, var(--db-collapse-control-lgbg) 100%);
  border-top-right-radius: 10px;
}

.btn-disabled-custom {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}

.duplicate-progress-bar {
  height: 10px !important;
  font-size: 14px;
}

.duplicate-progress-bar .progress-bar {
  background-color: #28a745 !important;
}

.duplicate-progress-message {
  min-height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 0;
  gap: 4px;
}

.duplicate-progress-count {
  font-weight: 600;
  font-size: 1.1rem;
}

.duplicate-progress-text {
  font-size: 0.95rem;
}

.duplicate-progress-label {
  font-size: 0.9rem;
  color: #6c757d;
  word-break: break-word;
}

#duplicateProjectModal .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

#duplicateProjectModal .custom-control-label {
  user-select: none;
}

.font-weight-500{
  font-weight: 500 !important;
}

.modal-body .invalid-feedback {
  background:#dc3545;
  color:#fff;
  padding:10px;
  font-size:1rem;
}

</style>
